import { createColumnDatetime, createColumnInput } from "../../../components/table/c-table.logic";
import i18n from "../../../i18n";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.event.ip"), dataIndex: "ip" }),
        createColumnInput({ title: () => i18n.global.t("model.event.username"), dataIndex: "username" }),
        createColumnInput({ title: () => i18n.global.t("model.event.full_name"), dataIndex: "full_name" }),
        createColumnInput({ title: () => i18n.global.t("model.event.menu_name"), dataIndex: "menu_name" }),
        createColumnDatetime({
            title: () => i18n.global.t("model.event.datetime"),
            dataIndex: "datetime"
        })
    ];
    return columns;
};

export const createField = () => {
    return [];
};
